// Constants
export const FIRESTORE_ARTICLES_COMMENTS_COLLECTIONS_PATH = "articleComments";

// Functions
export const getArticleCommentsCollectionPath = (articleId: string | number) => `${FIRESTORE_ARTICLES_COMMENTS_COLLECTIONS_PATH}/${articleId}/comments`